'use client';

import React, { FC, useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { RootStoreContext } from '@stores/rootStore';
import { PrintFilterDropdowns } from './PrintFilterDropdowns';
import { useActiveSeason, useActiveYear } from './hooks';
import { isPresent } from '@farmai-shared/LFUtils';
export const PrintHeader: FC = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    userStore: {
      user: {
        settings: {
          lang
        }
      }
    }
  } = useContext(RootStoreContext);
  const {
    activeSeason
  } = useActiveSeason();
  const {
    activeYearDisplay
  } = useActiveYear();
  const timePeriod = isPresent(activeSeason) ? activeSeason.name : activeYearDisplay;
  return <div className={`
        hidden shrink-0
        print:block
      `}>
      <div className={`
          font-heavy mb-8 hidden w-full rounded-xl border border-grey p-12 text-center text-6xl
          text-black
          print:mb-2 print:flex print:w-full print:justify-between print:border-none print:px-32
          print:py-0 print:font-bold print:text-lf-navy
        `}>
        <div className="relative flex items-center justify-center gap-x-2">
          <img className={`
              w-14
              print:block
            `} src="/static/assets/lf-logo-light-compact.svg" />
          <img className={`
              hidden w-38
              print:mt-4 print:block
            `} alt="overview-report-logo" src="/static/assets/lf-logo-light-text.svg" />
        </div>

        <h1 className="print:mt-2 print:text-5xl">
          {t('overviewReport', {
          timePeriod: timePeriod
        })}
        </h1>
        <p className={`
            hidden text-grey
            print:mt-4 print:block print:text-2xl print:font-thin
          `}>
          {t('generatedOn', {
          date: DateTime.now().reconfigure({
            outputCalendar: lang === 'th' ? 'buddhist' : 'gregory'
          }).toFormat('yyyy/MM/dd')
        })}
        </p>
      </div>
      <PrintFilterDropdowns timePeriod={timePeriod} />
    </div>;
});